import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const Shadow = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	position: fixed;
	inset: 0;
	background-color: var(--modal-fullscreen-bg);
	z-index: ${(props) => props.zIndex};
	backdrop-filter: blur(1.5px);

	&.modal-right-shadow,
	&.modal-left-shadow {
		> div {
			height: 100%;
			padding: 0;

			> button.closeBtn {
				top: 1rem;
				right: 1rem;

				body[dir='rtl'] & {
					right: unset;
					left: 1rem;
				}
			}

			> button.minimizeBtn {
				top: 1rem;
				right: 5rem;

				body[dir='rtl'] & {
					right: unset;
					left: 5rem;
				}
			}
		}
	}

	&.modal-right-shadow {
		align-items: flex-end;
	}

	&.modal-left-shadow {
		align-items: flex-start;
	}

	@media ${Breakpoints.mobile} {
		justify-content: flex-end;
	}
`;

export const Container = styled.div`
	display: flex;
	min-height: 20rem;
	padding: 2rem;
	${(props) => props.fullwidth && 'width: 100%;'}
	position: relative;

	form {
		padding: 0;
		border: none;
		border-radius: 0;
	}

	> button {
		position: absolute;

		&.closeBtn {
			top: 3rem;
			right: 3rem;

			body[dir='rtl'] & {
				right: unset;
				left: 3rem;
			}

			@media ${Breakpoints.mobile} {
				top: 7rem !important;
				right: 0 !important;

				body[dir='rtl'] & {
					right: unset !important;
					left: 0 !important;
				}
			}
		}

		&.minimizeBtn {
			top: 3rem;
			right: 8rem;

			body[dir='rtl'] & {
				right: unset;
				left: 8rem;
			}

			@media ${Breakpoints.mobile} {
				display: none;
			}
		}
	}

	&.xx-small {
		max-width: 40rem;
		@media (min-width: 800px) {
			> div {
				min-width: 30rem;
			}
		}
	}

	&.x-small {
		max-width: 60rem;
		@media (min-width: 800px) {
			> div {
				min-width: 50rem;
			}
		}
	}

	&.small {
		max-width: 80rem;
		@media (min-width: 800px) {
			> div {
				min-width: 70rem;
			}
		}
	}

	&.medium {
		max-width: 100rem;
		@media (min-width: 800px) {
			> div {
				min-width: 90rem;
			}
		}
	}

	&.large {
		max-width: 120rem;
	}

	&.x-large {
		max-width: 140rem;
	}

	&.xx-large {
		max-width: 160rem;
	}

	&.no-max-width {
		max-width: unset;
	}

	@media ${Breakpoints.mobile} {
		padding: var(--topBarHeight) 0 0 0 !important;
		max-width: unset !important;
		width: 100% !important;
	}
`;

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	${(props) => props.fullwidth && 'width: 100%;'}
	background-color: var(--modal-bg-1);
	padding: var(--padding-3);
	border-radius: var(--small-border-radius);
	box-shadow: var(--container-box-shadow);
	max-height: 100%;
	overflow: auto;

	@media ${Breakpoints.mobile} {
		padding: 0;
		border-radius: 2rem 2rem 0 0;
		width: 100%;
	}
`;

export const ModalTitle = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	color: var(--black);
	margin: 0 -1.5rem 1rem -1.5rem;
	padding: 0.5rem 2.5rem 2rem 2.5rem;

	> span.typography {
		flex: 0 0 auto;

		@media ${Breakpoints.mobile} {
			padding: var(--padding-4) var(--padding-3);
			font-weight: 500;
		}
	}

	:empty {
		padding: 2rem 2.5rem 2rem 2.5rem;
	}

	> div.progressWizard {
		width: 100%;

		@media (min-width: 767.98px) and (${Breakpoints.tablet}) {
			margin-right: 56px;
		}

		@media ${Breakpoints.mobile} {
			margin-top: var(--margin-2);
			width: -webkit-fill-available;
		}
	}

	@media ${Breakpoints.mobileLandscape} {
		display: block;
	}

	@media ${Breakpoints.mobile} {
		padding: 0;
		margin: 0;
	}
`;

export const ModalContent = styled.div`
	display: block;
	overflow: auto;

	> div.progressWizard {
		margin-bottom: 1rem;

		@media ${Breakpoints.mobile} {
			margin-bottom: unset;
		}
	}
`;

export const ModalActions = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: right;
	margin: 1rem -1.5rem 0 -1.5rem;
	padding: 2rem 1.5rem 0rem 1.5rem;
	border-top: 1px solid var(--border-color);
	gap: var(--margin-2);

	body[dir='rtl'] & {
		justify-content: left;

		.icon {
			transform: scaleX(-1);
		}
	}

	@media ${Breakpoints.mobile} {
		margin: 0;
		padding: var(--padding-3) var(--padding-3) var(--padding-3) var(--padding-3);
		box-shadow: 0px -3px 17px 0px #0000001a;
	}
`;
